module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_7005.e00c75b2.png";